export default "__VITE_ASSET__DPj_LEP2__"